import React from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { addCourses } from '../../../store/actions/UserAction';
import CoursesFormContainer from './CoursesFormContainer';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';

import './AddCourses.scss';


var Scroll = require('react-scroll');
var scroller = Scroll.scroller;

function AddCourses(props) {
  const {
    uid,
    nElem,
    evento,
    helper,
    helperTrue,
    helperFalse,
    addCourses,
    handleSnack,
    alreadyRewarded,
    handleRewarded,
    coursesLawyer,
    handleTrophieModalOpen,
    showLoading, 
    hideLoading,
    getValues,
    handleIsLimit,
  } = props;


  const isObjectFull = (array) => {
    const allValues = Object.values(array.slice(-1).pop())
    const evaluation = allValues.every(elem => {
        if (elem !== '') {
            return true
        }
        return false
    })
    return evaluation;
  }

  const handleSubmit = async (
    values,
    { setSubmitting, setFieldError, resetForm }
  ) => {
    setSubmitting(false);
   
    let boolValues = isObjectFull(values.coursesLawyer)

    if (boolValues === false) {
      handleRewarded(false)
    }
    
    showLoading();
    addCourses(
      uid,
      values.coursesLawyer,
      coursesLawyer,
      boolValues
    ).then(res => { 
      hideLoading();
      resetTab();
      resetForm();
      if (!alreadyRewarded) {
        handleTrophieModalOpen(boolValues)
      }else{
        setTimeout(() => {
          handleSnack();
        }, 0)
      }
    })
  };

  const formValues = {
    coursesLawyer: [
      {
        name: '',
        place: '',
        firstYear: '',
        lastYear: '',
      },
    ],
  };

  const resetTab = () => {
    scroller.scrollTo('courses_section', { smooth: true, offset: -64 });
    evento(false);
  };

  return (
    <>
      <div className="addCourses">
        <Formik
          initialValues={formValues}
          onSubmit={handleSubmit}
          render={props => (
            <CoursesFormContainer 
              evento={resetTab}
              nElem={nElem}
              {...props}
              uid={uid}
              helper={helper}
              helperTrue={helperTrue}
              helperFalse={helperFalse}
              getValues={getValues}
              handleIsLimit={handleIsLimit}
            />
            
          )}
        />
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  coursesLawyer: state.authClient.coursesLawyer,
});

const mapDispatchToProps = dispatch => ({
  addCourses: (uid, values, coursesLawyer, boolValues) =>
    dispatch(addCourses(uid, values, coursesLawyer, boolValues)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddCourses);
